import { DataErrorImg } from '~/assets/img/common';

export function CampaignNotFound() {
  return (
    <div className="flex h-[220px] w-full flex-col items-center justify-center gap-8 rounded-16 border border-solid border-02 p-20">
      <img src={DataErrorImg.src} className="size-64" alt="error guide" />
      <div className="flex flex-col items-center gap-4">
        <strong className="text-description typo-title100-semibold">
          메시지로 나간 상품이 없습니다.
        </strong>
        <p className="text-hint typo-caption100-regular">
          다른 상품을 확인해보세요.
        </p>
      </div>
    </div>
  );
}
